module.exports = __webpack_public_path__ + "static/media/PeaceOut.7b29e7ac.jpg";